// Per le pagine di statistiche: richiama carica() alla creazione e a ogni cambio
// del periodo condiviso (store statistiche). Ogni pagina definisce carica().
// Con dal > al non ricarica (l'API risponderebbe 400): il filtro mostra l'avviso.
export default {
    computed: {
        periodo() {
            return this.$store.getters["statistiche/periodo"];
        },
    },

    watch: {
        periodo: {
            immediate: true,
            handler(p) {
                if (p.dal && p.al && p.dal > p.al) return;
                this.carica();
            },
        },
    },
}
